import {
  LOAD_PRODUCTTYPE,
  SHOW_PRODUCTTYPE,
  CREATE_PRODUCTTYPE,
  UPDATE_PRODUCTTYPE,
  DELETE_PRODUCTTYPE,
  IMPORT_PRODUCTTYPE,
  EXPORT_PRODUCTTYPE,
} from "./actions";

const msg = {
  success_msg: "",
  err_msg: "",
};

const initialState = {
  lists: [],
  total_rows: 0,
  loading: false,
  shouldReload: false,
  data: {
    id: "",
    name: "",
    code: "",
  },
  ...msg,
};

export default (state = initialState, action) => {
  switch (action.type) {
    // case LOAD_PRODUCTTYPE.REQUEST:
    case UPDATE_PRODUCTTYPE.REQUEST:
    case CREATE_PRODUCTTYPE.REQUEST:
    case DELETE_PRODUCTTYPE.REQUEST:
    case IMPORT_PRODUCTTYPE.REQUEST:
    case EXPORT_PRODUCTTYPE.REQUEST:
      return {
        ...state,
        ...msg,
        loading: true,
        shouldReload: false
      };
    case LOAD_PRODUCTTYPE.REQUEST:
      return {
        ...state,
        data: initialState.data,
        ...msg,
        loading: true,
        shouldReload: false
      };
    case SHOW_PRODUCTTYPE.REQUEST:
      return {
        ...initialState,
        ...msg,
        loading: true,
        shouldReload: false
      };


    case LOAD_PRODUCTTYPE.SUCCESS:
      return {
        ...state,
        lists: action.payload.data.data,
        total_rows: action.payload.data.total_rows,
        loading: false,
      };

    case SHOW_PRODUCTTYPE.SUCCESS:
      return {
        ...state,
        data: action.payload.data.data,
        loading: false,
      };

    case CREATE_PRODUCTTYPE.SUCCESS:
      return {
        ...state,
        success_msg: "save_success",
        loading: false,
      };

    case UPDATE_PRODUCTTYPE.SUCCESS:
      return {
        ...state,
        success_msg: "edit_success",
        loading: false,
      };

    case DELETE_PRODUCTTYPE.SUCCESS:
      return {
        ...state,
        success_msg: "delete_success",
        lists: state.lists.filter((x) => x.id !== action.payload.id),
        loading: false,
        shouldReload: true
      };

    case IMPORT_PRODUCTTYPE.SUCCESS:
      return {
        ...state,
        success_msg: "import_success",
        loading: false,
        shouldReload: true,
      };

    case EXPORT_PRODUCTTYPE.SUCCESS:
      return {
        ...state,
        success_msg: "export_success",
        loading: false,
      };
    case LOAD_PRODUCTTYPE.FAILURE:
    case SHOW_PRODUCTTYPE.FAILURE:
    case CREATE_PRODUCTTYPE.FAILURE:
    case UPDATE_PRODUCTTYPE.FAILURE:
    case DELETE_PRODUCTTYPE.FAILURE:
    case IMPORT_PRODUCTTYPE.FAILURE:
    case EXPORT_PRODUCTTYPE.FAILURE:
      return {
        ...state,
        err_msg: action.payload.err,
        loading: false,
        shouldReload: false
      };

    default:
      return state;
  }
};
